import React from "react";
import moment from "moment";

import {Static2} from "@common/react/static-2";
import {cs} from "@common/react/chain-services";

import {formatDateTime} from "@common/logic/date-time/format-date-time";
import {VerticalBar} from "@common/ui-components/charts/vertical-bar/vertical-bar";
import {cChartOuterLayout} from "@common/ui-components/charts/chart-layout/chart-outer-layout";
import {interactionComboChartTheme} from "../interaction/chart/interaction-combo-chart-config";

export const formatLast30Days = (data) =>
    cs(
        [
            "formatMDate",
            (_, next) =>
                next((d) => ({
                    year: d.get("year"),
                    month: d.get("month") + 1,
                    day: d.get("date"),
                })),
        ],
        ({formatMDate}) => {
            return Array.from(Array(30)).map((_, index) => {
                // const date = formatDateTime({ date: formatMDate(moment().subtract( 30 - (index + 1), 'd'))})
                const date = moment().subtract(30 - (index + 1), "d");

                const value = data
                    .map((item) => {
                        const found = item.synchronizations.filter((s) => moment(s.date).isSame(date, "day"));
                        return found.reduce((prev, it) => (prev += it.records), 0);
                    })
                    .reduce((prev, value) => (prev += value), 0);

                return [new Date(formatDateTime({date: formatMDate(date)})).getTime(), value];
            });
        }
    );

export const SyncSummaryLast30Days = ({data}) =>
    cs(
        ["chartRef", (_, next) => Static2({next})],
        [
            "tile",
            (_, next) =>
                next({
                    id: "33cd9ed6-4a8d-4c52-b735-3c3098681176",
                    xAxisField: {
                        id: "07e72321-ccc3-4be4-99d4-b3ae62c0d53d",
                        modelID: "4b486f2b-3ffc-4026-a3fc-2a5e51d48403",
                        modelTableID: "441d9abb-1695-41a4-b904-0bca100d5a9e",
                        modelColumnID: "5035cb8a-55ef-45e5-9772-4a2a019d89b4",
                        displayName: "DatePlacedUtc",
                        dataType: "DateTime",
                        numericProperties: null,
                        dateProperties: {
                            aggregation: "Weeks",
                            format: "M/d/yy",
                        },
                        $type: "DimensionTileField",
                    },
                    yAxisFields: [
                        {
                            id: "07eff964-8b6d-4634-bcbc-bc63481338bd",
                            measureFields: [
                                {
                                    id: "07eff964-8b6d-4634-bcbc-bc63481338bd",
                                    aggregationFunc: "Count",
                                    modelID: "4b486f2b-3ffc-4026-a3fc-2a5e51d48403",
                                    modelTableID: "441d9abb-1695-41a4-b904-0bca100d5a9e",
                                    modelColumnID: "70950103-ccd1-4252-ab48-cac39c1e3329",
                                    displayName: "Records",
                                    dataType: "IDUUID",
                                    numericProperties: {
                                        displayType: "Number",
                                        decimalSeperator: "Dot",
                                        thousandsSeperator: "Comma",
                                        decimalPlaces: 0,
                                        shiftDecimalPlaceLeft: null,
                                        negativeFormat: "Parentheses",
                                        currencyProperties: null,
                                    },
                                    dateProperties: null,
                                    $type: "MeasureTileField",
                                },
                            ],
                        },
                    ],
                    groupField: null,
                    referenceLines: [],
                    style: {
                        yAxis: {
                            "07eff964-8b6d-4634-bcbc-bc63481338bd": {
                                labelShown: false,
                                label: null,
                                range: "AutoFrom0",
                                rangeCustomMin: null,
                                rangeCustomMax: null,
                                gridStepType: null,
                                gridStepNumeric: null,
                                gridStepLabelsShown: false,
                                gridStepLabelOrientation: null,
                                lineShown: false,
                                location: "RightBottom",
                                gridLinesShown: false,
                                showInfoIcon: false,
                                infoIconText: null,
                                cumulative: false,
                                logarithmic: false,
                                $type: "BarChartMeasureAxisStyle",
                            },
                        },
                        xAxis: {
                            labelShown: false,
                            label: null,
                            gridStepType: null,
                            gridStepNumeric: 3,
                            gridStepLabelsShown: false,
                            gridStepLabelOrientation: "Auto",
                            maxValuesInView: "AutoMax",
                            maxValuesInViewFixed: null,
                            lineShown: false,
                            gridLinesShown: false,
                            dateGaps: "FillWithZero",
                            showInfoIcon: false,
                            infoIconText: null,
                            $type: "BarChartDimensionAxisStyle",
                        },
                        multipleAxisOption: "IndependentAxes",
                        dataLabels: {
                            show: false,
                            allowOverlap: false,
                            position: "OutsideAbove",
                            $type: "DataLabelsTileStyle",
                        },
                        displayType: "Classic",
                        legendStyle: {
                            legendShown: false,
                            legendTitleShown: false,
                            legendTitle: "Legend",
                            legendPosition: "Bottom",
                            legendSize: null,
                            legendContent: "Label",
                            legendComparisonType: null,
                        },
                        barDataColorAppliedBy: "Measure",
                        colorApplications: {
                            "07eff964-8b6d-4634-bcbc-bc63481338bd": {
                                index: 10,
                                $type: "DiscreteColorApplication",
                            },
                        },
                        title: {show: false, titleLocation: "Above"},
                        dataColorPalette: [],
                        showCompare: false,
                        showDownloadData: false,
                        downloadFormat: null,
                        showDownloadImage: false,
                        showTitleInfoIcon: false,
                        titleInfoIconText: "dasdasdasda",
                        $type: "VerticalBarChartTileStyle",
                    },
                    title: "3",
                    filters: [
                        {
                            id: "113224ad-37d4-457b-94cc-45d5e3bcccd9",
                            options: 0,
                            defaultOption: "Custom",
                            customRange: {
                                dateStart: "2016-02-01T00:00:00Z",
                                dateEnd: "2016-03-31T00:00:00Z",
                                $type: "InRangeCustomDateFilterRange",
                            },
                            compareEnabled: true,
                            compareOnByDefault: true,
                            compareDefaultRange: "PreviousPeriod",
                            includeNullDates: false,
                            label: "Date Placed Utc (Order)",
                            showLabelInfoIcon: false,
                            labelInfoIconText: null,
                            columns: [
                                {
                                    modelID: "4b486f2b-3ffc-4026-a3fc-2a5e51d48403",
                                    modelTableID: "441d9abb-1695-41a4-b904-0bca100d5a9e",
                                    modelColumnID: "5035cb8a-55ef-45e5-9772-4a2a019d89b4",
                                    displayName: null,
                                    default: true,
                                },
                            ],
                            multiSelectionOption: "SingleSelect",
                            required: false,
                            displayArea: "Visible",
                            disconnectedTiles: [],
                            $type: "DateFilter",
                        },
                    ],
                    sort: [
                        {
                            direction: "Asc",
                            modelID: "4b486f2b-3ffc-4026-a3fc-2a5e51d48403",
                            modelTableID: "441d9abb-1695-41a4-b904-0bca100d5a9e",
                            modelColumnID: "5035cb8a-55ef-45e5-9772-4a2a019d89b4",
                            aggregationFunc: "None",
                        },
                    ],
                    categorySort: null,
                    categorySortBasis: null,
                    limit: null,
                    tileActions: [],
                    fieldValidity: "Valid",
                    $type: "VerticalBarChartTile",
                }),
        ],
        [
            "data",
            (_, next) =>
                next({
                    $type: "ChartTileData",
                    series: [
                        {
                            tileFieldID: "07eff964-8b6d-4634-bcbc-bc63481338bd",
                            name: "Records",
                            measureAxisTitle: "Records",
                            stack: "07eff964-8b6d-4634-bcbc-bc63481338bd",
                            data: data,
                            isCompare: false,
                            range: {
                                dateStart: "2016-02-01T00:00:00Z",
                                dateEnd: "2016-03-31T00:00:00Z",
                            },
                            legendIndex: 0,
                            tileActionData: {data: [], columns: []},
                        },
                        {
                            tileFieldID: "07eff964-8b6d-4634-bcbc-bc63481338bd",
                            name: "Records",
                            measureAxisTitle: "Records",
                            stack: "07eff964-8b6d-4634-bcbc-bc63481338bd",
                            isCompare: true,
                            range: null,
                            legendIndex: 0,
                            tileActionData: null,
                        },
                    ],
                    tileID: "33cd9ed6-4a8d-4c52-b735-3c3098681176",
                    fieldValidity: "Valid",
                    resultsTruncated: false,
                    sql: [
                        "WITH CTE0 AS ( /* Select All Cols Needed */\r\n                    SELECT  DATE_ADD(\u0027day\u0027, -1, DATE_TRUNC(\u0027weeks\u0027, \u0022dt_1aabe9bdf0cf_groupmatics_dbo_order\u0022.\u0022groupmatics_dbo_order_dateplacedutc\u0022::TIMESTAMP)) AS \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_1\u0022, \u0022dt_1aabe9bdf0cf_groupmatics_dbo_order\u0022.\u0022groupmatics_dbo_order_orderid\u0022 AS \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_70950103-ccd1-4252-ab48-cac39c1e3329_-1\u0022, \u0022dt_1aabe9bdf0cf_groupmatics_dbo_order\u0022.\u0022groupmatics_dbo_order_dateplacedutc\u0022 AS \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_-1\u0022 FROM \u0022t_595745e5_d238_4ff4_905e_6fb73de9d98d_c57c0db1_7310_42cb_8474_9b360cad3845_l\u0022.\u0022dt_1aabe9bdf0cf_groupmatics_dbo_order\u0022 \r\n                    ),CTE1 AS ( /* Filter 113224ad-37d4-457b-94cc-45d5e3bcccd9 */\r\n                                SELECT * , CASE\r\n                                            WHEN ((\u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_-1\u0022 \u003E= \u00272016-02-01 00:00\u0027 AND \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_-1\u0022 \u003C \u00272016-04-01 00:00\u0027)) THEN 1\r\n                                            ELSE NULL\r\n                                        END AS \u0022fil_113224ad_37d4_457b_94cc_45d5e3bcccd9\u0022 FROM CTE0\r\n                                WHERE ((((\u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_-1\u0022 \u003E= \u00272016-02-01 00:00\u0027 AND \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_-1\u0022 \u003C \u00272016-04-01 00:00\u0027))))  AND (\u0022fil_113224ad_37d4_457b_94cc_45d5e3bcccd9\u0022 IS NOT NULL)\r\n                            UNION ALL\r\n\r\n                                SELECT * , CASE\r\n                                            WHEN ((\u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_-1\u0022 \u003E= \u00272015-12-03 00:00\u0027 AND \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_-1\u0022 \u003C \u00272016-02-01 00:00\u0027)) THEN 2\r\n                                            ELSE NULL\r\n                                        END AS \u0022fil_113224ad_37d4_457b_94cc_45d5e3bcccd9\u0022 FROM CTE0\r\n                                WHERE ((((\u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_-1\u0022 \u003E= \u00272015-12-03 00:00\u0027 AND \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_-1\u0022 \u003C \u00272016-02-01 00:00\u0027))))  AND (\u0022fil_113224ad_37d4_457b_94cc_45d5e3bcccd9\u0022 IS NOT NULL) ),CTE2 AS ( /* Main SELECT */\r\n                        SELECT \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_1\u0022, COUNT(\u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_70950103-ccd1-4252-ab48-cac39c1e3329_-1\u0022) AS \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_70950103-ccd1-4252-ab48-cac39c1e3329_-1_1\u0022, \u0022fil_113224ad_37d4_457b_94cc_45d5e3bcccd9\u0022  FROM CTE1 GROUP BY \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_1\u0022, \u0022fil_113224ad_37d4_457b_94cc_45d5e3bcccd9\u0022\r\n                        ) SELECT \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_1\u0022, \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_70950103-ccd1-4252-ab48-cac39c1e3329_-1_1\u0022, \u0022fil_113224ad_37d4_457b_94cc_45d5e3bcccd9\u0022 FROM CTE2 ORDER BY \u0022c_441d9abb-1695-41a4-b904-0bca100d5a9e_5035cb8a-55ef-45e5-9772-4a2a019d89b4_1\u0022 Asc LIMIT 400000",
                    ],
                    publishIDs: [],
                }),
        ],
        ({chartRef, tile, data}) => {
            const size = {width: 4, height: 4};
            const theme = interactionComboChartTheme;
            const chartOuterLayout = cChartOuterLayout({
                tile,
                size,
                theme,
            });

            return (
                <div
                    className="chart-content-container"
                    style={{
                        position: "relative",
                        overflow: "hidden",
                        height: 190,
                        width: 279,
                        // border: "1px solid #E9ECEF",
                        // backgroundColor: theme?.tileBackgroundColorRGB,
                        // borderColor: theme?.tileBorderColorRGB ?? "#E9ECEF",
                        // borderRadius: theme?.tileCornerRadius ?? 3,
                        // borderWidth: theme?.tileBorderWidth ?? 1,
                        // boxShadow: theme?.tileShadow ? "0 2px 8px 6px rgba(7, 6, 6, 0.05)" : "",
                    }}
                >
                    {chartOuterLayout({
                        content: (props) => (
                            <VerticalBar
                                chartRef={chartRef}
                                tile={tile}
                                theme={theme}
                                size={{width: 279, height: 190}}
                                defaultData={data}
                                tileFilters={{
                                    invalid: false,
                                    key: 1636382964080,
                                    getValue: () => ({}),
                                }}
                            />
                        ),
                    })}
                </div>
            );
        }
    );
